import type { PrismRuntimeConfig } from './prismTypes';

interface CreatePrismRuntimeConfigInput {
  height: number;
  baseWidth: number;
  glow: number;
  noise: number;
  offsetX: number;
  offsetY: number;
  transparent: boolean;
  scale: number;
  hueShift: number;
  colorFrequency: number;
  bloom: number;
  timeScale: number;
  hoverStrength: number;
  inertia: number;
}

export function createPrismRuntimeConfig({
  height,
  baseWidth,
  glow,
  noise,
  offsetX,
  offsetY,
  transparent,
  scale,
  hueShift,
  colorFrequency,
  bloom,
  timeScale,
  hoverStrength,
  inertia,
}: CreatePrismRuntimeConfigInput): PrismRuntimeConfig {
  const prismHeight = normalizeAtLeast(height, 0.001);
  const prismBaseWidth = normalizeAtLeast(baseWidth, 0.001);
  const baseHalf = prismBaseWidth * 0.5;

  return {
    height: prismHeight,
    baseHalf,
    glow: normalizeAtLeast(glow, 0.0),
    noise: normalizeAtLeast(noise, 0.0),
    offsetX,
    offsetY,
    saturation: getPrismSaturation(transparent),
    scale: normalizeAtLeast(scale, 0.001),
    hueShift: fallbackNumber(hueShift, 0),
    colorFrequency: normalizeAtLeast(fallbackNumber(colorFrequency, 1), 0.0),
    bloom: normalizeAtLeast(fallbackNumber(bloom, 1), 0.0),
    timeScale: normalizeAtLeast(fallbackNumber(timeScale, 1), 0),
    hoverStrength: normalizeAtLeast(fallbackNumber(hoverStrength, 1), 0),
    inertia: clampUnit(fallbackNumber(inertia, 0.12)),
  };
}

function normalizeAtLeast(value: number, minimum: number): number {
  return Math.max(minimum, value);
}

function fallbackNumber(value: number, fallback: number): number {
  return value || fallback;
}

function getPrismSaturation(transparent: boolean): number {
  if (transparent) return 1.5;
  return 1;
}

function clampUnit(value: number): number {
  return Math.max(0, Math.min(1, value));
}
